var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.53898C0 6.15368 0.154362 6.72828 0.469799 7.25612C0.785235 7.78396 1.20805 8.21158 1.74497 8.52561C2.28188 8.83964 2.85906 9 3.48322 9C4.10738 9 4.69128 8.83964 5.2349 8.52561C5.77852 8.21158 6.20805 7.78396 6.52349 7.25612C6.83893 6.7216 7 6.15368 7 5.53898C7 5.13808 6.88591 4.6637 6.65101 4.10913C6.41611 3.55457 6.13423 3.04009 5.80537 2.57238C5.51007 2.19154 5.16107 1.7706 4.75839 1.31626C4.3557 0.861916 3.65101 0.160356 3.48993 0L2.63087 0.861915C2.21476 1.26281 1.81208 1.72383 1.42953 2.25167C1.04698 2.77951 0.711409 3.34744 0.42953 3.95546C0.134228 4.56347 0 5.09131 0 5.53898Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.2a847a64fad7e890b0cc46a67b90f04f.svg";
export { ForwardRef as ReactComponent };